import React, { useState, useEffect, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Alert, Collapse } from 'reactstrap';
import { clearFields, Field, reduxForm } from 'redux-form';
import { IconButton, Tooltip } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import columns from './ColumnsAlertNotification';
import renderField from '../../../shared/components/form/RenderField';
import { TYPE_NOTIFICATIONS } from '../../../shared/utils/constants';
import { onShowAlert } from '../../../shared/utils/smartutils';
import MatTable from '../../../shared/components/material-table';
import SelectVirtualized from '../../../shared/components/form/SelectVirtualized';

const AlertNotifications = (props) => {
  const { t, dispatch, data, onChangeAlertNotificationList, initialize } =
    props;
  const alertNotificationInitialState = {
    id: 0,
    timeNotification: 1,
  };
  const [alertNotification, setAlertNotification] = useState(
    alertNotificationInitialState
  );
  const [notification, setNotification] = useState({});
  const [alertsNotifications, setAlertsNotifications] = useState([]);
  const [isInvalidAlert, setIsInvalidAlert] = useState(false);
  const typeNotification = [
    {
      value: TYPE_NOTIFICATIONS.TYPE_WEEK,
      label: t(`calendar.type-notification.${TYPE_NOTIFICATIONS.TYPE_WEEK}`),
    },
    {
      value: TYPE_NOTIFICATIONS.TYPE_DAY,
      label: t(`calendar.type-notification.${TYPE_NOTIFICATIONS.TYPE_DAY}`),
    },
    {
      value: TYPE_NOTIFICATIONS.TYPE_HOUR,
      label: t(`calendar.type-notification.${TYPE_NOTIFICATIONS.TYPE_HOUR}`),
    },
    {
      value: TYPE_NOTIFICATIONS.TYPE_MINUTE,
      label: t(`calendar.type-notification.${TYPE_NOTIFICATIONS.TYPE_MINUTE}`),
    },
  ];

  const onRemoveAlertClick = (evt, rowData) => {
    const found = alertsNotifications.findIndex(
      (element) => element === rowData
    );
    const updated = [...alertsNotifications];
    updated.splice(found, 1);
    setAlertsNotifications(updated);
  };

  const validateAlertToAdd = (notificationToAdd) => {
    const itemFound = alertsNotifications.find(
      (item) =>
        item.timeNotification === notificationToAdd.timeNotification &&
        item.typeNotification === notificationToAdd.typeNotification
    );
    if (itemFound) {
      setIsInvalidAlert(!isInvalidAlert);
      return false;
    }
    return true;
  };

  const onContentInputChange = (evt) => {
    if (evt) {
      if (
        !Number.isInteger(evt.target.value) &&
        evt.target.value.includes('.')
      ) {
        setIsInvalidAlert(!isInvalidAlert);
        onShowAlert(
          'warning',
          'errors.title',
          'answers.validation.enter-integer',
          setNotification
        );
      } else if (evt.target.value <= 0 || evt.target.value > 99) {
        setIsInvalidAlert(!isInvalidAlert);

        onShowAlert(
          'warning',
          'errors.title',
          'answers.validation.enter-value-between-one-ninety-nine',
          setNotification
        );
      } else {
        const updatedAlertNotifications = { ...alertNotification };
        const newValue = parseInt(evt.target.value, 10);
        if (!Number.isNaN(newValue)) {
          updatedAlertNotifications[evt.target.name] = newValue;
        }
        setAlertNotification(updatedAlertNotifications);
      }
    }
  };

  const onContentSelectChange = (field, value) => {
    const updatedAlertNotifications = { ...alertNotification };
    updatedAlertNotifications[field] = value.value;
    setAlertNotification(updatedAlertNotifications);
  };

  const onAddAlertClick = () => {
    const updatedAlertNotifications = [
      ...alertsNotifications,
      alertNotification,
    ];
    const advanceToAdd = alertNotification;
    const valid = validateAlertToAdd(advanceToAdd);
    if (
      Object.keys(alertNotification).length !== 0 &&
      alertNotification.typeNotification
    ) {
      if (valid) {
        setAlertsNotifications(updatedAlertNotifications);
        setAlertNotification(alertNotificationInitialState);
      } else {
        onShowAlert(
          'warning',
          'errors.title',
          'answers.validation.alert-registered',
          setNotification
        );
      }
    } else {
      onShowAlert(
        'warning',
        'errors.title',
        'answers.validation.select-alert',
        setNotification
      );
    }
  };

  useEffect(() => {
    setAlertsNotifications(data);
    return () => {
      setAlertsNotifications([]);
    };
  }, [data]);

  useEffect(() => {
    onChangeAlertNotificationList(alertsNotifications);
    dispatch(
      clearFields(
        'alertNotificationForm',
        true,
        true,
        true,
        ...['timeNotification', 'typeNotification']
      )
    );
  }, [alertsNotifications]);

  useLayoutEffect(() => {
    dispatch(
      clearFields(
        'alertNotificationForm',
        true,
        true,
        true,
        ...['timeNotification', 'typeNotification']
      )
    );
  }, [isInvalidAlert]);

  useEffect(() => {
    initialize(alertNotification);
  }, []);

  return (
    <>
      <span className="modal__form__form-group-label">
        {t('calendar.alert')}
      </span>
      <div className="form__form-group--3_columns d-flex mg-tb10">
        <div className="form_form-group position-relative">
          <div className="modal__form_form-group-field">
            <Field
              name="timeNotification"
              type="number"
              max="100"
              min="1"
              component={renderField}
              onBlur={(evt) => {
                onContentInputChange(evt);
              }}
            />
          </div>
        </div>
        <div className="select-notification">
          <Field
            name="typeNotification"
            component={SelectVirtualized}
            isClearable={false}
            options={typeNotification}
            onChange={(value) => {
              onContentSelectChange('typeNotification', value);
            }}
            placeholder={t('calendar.placeholders.select')}
          />
        </div>
        <span className="form__form-group-label span-notification">
          {t('calendar.info-alert')}
        </span>
        <div className="d-flex justify-content-end">
          <Tooltip title={t('general.addnotification')}>
            <IconButton
              className="icon-button"
              aria-label="add"
              onClick={onAddAlertClick}
            >
              <AddIcon />
            </IconButton>
          </Tooltip>
        </div>
      </div>
      <Collapse isOpen={notification.status} className="width100 text-center">
        <Alert color={notification.color}>{t(notification.message)}</Alert>
      </Collapse>
      <div className="form__form-group">
        <MatTable
          data={alertsNotifications}
          columns={columns(t)}
          onRemoveClick={onRemoveAlertClick}
          paging={false}
          showTitle={false}
          search={false}
          toolbar={false}
          isFiltering
        />
      </div>
    </>
  );
};

AlertNotifications.propTypes = {
  t: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)),
  onChangeAlertNotificationList: PropTypes.func.isRequired,
};

AlertNotifications.defaultProps = {
  data: [],
};
export default withTranslation('common')(
  reduxForm({
    form: 'alertNotificationForm',
  })(AlertNotifications)
);
